import { HTMLAttributes } from 'react';

export enum AVideoAspectRatio {
  Ratio1x1 = '1:1',
  Ratio2x3 = '2:3',
  Ratio5x2 = '5:2',
  Ratio16x9 = '16:9',
  Ratio3x2 = '3:2',
}

export type AVideoProps = HTMLAttributes<HTMLDivElement> & {
  aspectRatio?: AVideoAspectRatio;
  src: string;
  poster?: string;
  title?: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
  playsInline?: boolean;
};
